module.exports = __webpack_public_path__ + "static/media/msnp32_wrkgrp_icon.83b3f2e5.ico";